﻿import * as $ from 'jquery';
import { IEventAggregator } from 'common/barrels/core';
import { IResourceProvider } from 'common/resourceprovider';
import { IDialog, IDialogOptions } from 'runtime/dialogs/dialog';
import { SelectAllPreference } from 'runtime/data/selectallpreference';
import { WorkTraySelectAllRequested } from 'runtime/events/worktrayselectallrequested';

export class SelectAllDialog implements IDialog {
    options: IDialogOptions;
    private dialogContent: JQuery;

    constructor(eventAggregator: IEventAggregator, resources: IResourceProvider) {
        this.options = {
            title: resources.getCoreString('LblSelectAll'),
            width: 480,
            height: 200,
            dialogClass: 'wf-worktray-item-dialog',
            buttons: [
                { text: resources.getCoreString('XamlCurrentPage'), click: (): void => eventAggregator.publish(new WorkTraySelectAllRequested(SelectAllPreference.allCurrentPage, () => this.close())) },
                { text: resources.getCoreString('XamlAll'), click: (): void => eventAggregator.publish(new WorkTraySelectAllRequested(SelectAllPreference.all, () => this.close())) },
                { text: resources.getCoreString('XamlClose'), click: () => this.dialogContent.dialog('close') }
            ],
            create: () => {
                $('.ui-dialog-buttonset > button', this.dialogContent.parent()).css('min-width', '110px');
            }
        };
        this.dialogContent = this.buildContent(resources);
    }

    content(): JQuery {
        return this.dialogContent;
    }

    close(): void {
        this.dialogContent.dialog('close');
    }

    private buildContent(resources: IResourceProvider): JQuery {
        return $('<div />').append([
            $('<div />').addClass('form-group').append([
                $('<div />').text(resources.getCoreString('XamlSelectAllDialogMessage'))
            ])
        ]);
    }
}